"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldWrapper = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var styled_1 = __importDefault(require("@emotion/styled"));
var react_1 = __importDefault(require("react"));
var FieldHeading_1 = require("../FieldHeading");
var StyledComment = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  line-height: 1.7;\n  font-size: 14px;\n  color: ", ";\n  word-break: break-all;\n  margin-top: 4px;\n\n  label: Comment;\n"], ["\n  line-height: 1.7;\n  font-size: 14px;\n  color: ", ";\n  word-break: break-all;\n  margin-top: 4px;\n\n  label: Comment;\n"])), function (_a) {
    var color = _a.color;
    return color;
});
var StyledNote = styled_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  line-height: 1.7;\n  font-size: 12px;\n  color: ", ";\n  word-break: break-all;\n  margin-top: 4px;\n\n  label: Note;\n"], ["\n  line-height: 1.7;\n  font-size: 12px;\n  color: ", ";\n  word-break: break-all;\n  margin-top: 4px;\n\n  label: Note;\n"])), function (_a) {
    var color = _a.color;
    return color;
});
var InputWrapper = styled_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-top: 4px;\n\n  label: InputBlock;\n"], ["\n  margin-top: 4px;\n\n  label: InputBlock;\n"])));
exports.FieldWrapper = react_1.default.memo(function (_a) {
    var name = _a.name, note = _a.note, comment = _a.comment, required = _a.required, children = _a.children, design = _a.design, className = _a.className, displayRequiredLabel = _a.displayRequiredLabel, propertyId = _a.propertyId, notUseLabelTag = _a.notUseLabelTag, _b = _a.isFileUploadItem, isFileUploadItem = _b === void 0 ? false : _b;
    var _c = design.colors, propertyTitleFont = _c.propertyTitleFont, commentColor = _c.comment, noticeAndGuideFont = _c.noticeAndGuideFont;
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: className }, { children: [(0, jsx_runtime_1.jsx)(FieldHeading_1.FieldHeading, { color: propertyTitleFont, name: name, required: required, displayRequiredLabel: displayRequiredLabel, propertyId: propertyId, notUseLabelTag: notUseLabelTag, isFileUploadItem: isFileUploadItem }), comment != null && comment !== '' && ((0, jsx_runtime_1.jsx)(StyledComment, { color: commentColor, dangerouslySetInnerHTML: {
                    __html: comment,
                } })), (0, jsx_runtime_1.jsx)(InputWrapper, { children: children }), note != null && note !== '' && ((0, jsx_runtime_1.jsx)(StyledNote, { color: noticeAndGuideFont, dangerouslySetInnerHTML: {
                    __html: note,
                } }))] })));
});
var templateObject_1, templateObject_2, templateObject_3;
